import React from 'react';
import { Link } from 'react-router-dom';

const CLOTHO_URL = 'https://clothoio.com';

const ciesseServices = [
  {
    title: 'Camere climatiche e prove ambientali',
    desc: 'Manutenzione, assistenza e riparazione su camere climatiche, fitologiche e impianti per prove ambientali.',
  },
  {
    title: 'Celle frigorifere BT/TN',
    desc: 'Installazione, montaggio, ricerca guasti e interventi su celle fredde, frigoriferi e congelatori industriali.',
  },
  {
    title: 'Certificazioni temperatura e umidità',
    desc: 'Controlli, verifiche e certificazioni per ambienti dove stabilità e tracciabilità dei parametri sono fondamentali.',
  },
];

const clothoProducts = [
  {
    name: 'Clotho Pulse',
    label: 'Nodo sensori',
    desc: 'Dispositivo per il monitoraggio di temperature fino a -80°C, con versioni modulari per umidità e pressione.',
    tags: ['-80°C', 'Sensori', 'Modulare'],
    logo: '/clotho-pulse-logo.png',
    image: '/clotho-pulse-device.png',
  },
  {
    name: 'Clotho Nexus',
    label: 'Gateway LoRa',
    desc: 'Raccoglie i dati dai dispositivi in campo e abilita la comunicazione bidirezionale verso la piattaforma.',
    tags: ['LoRa', 'Gateway', 'Bidirezionale'],
    logo: '/clotho-nexus-logo.png',
    image: '/clotho-nexus-device.png',
  },
  {
    name: 'Clotho Cloud',
    label: 'Dashboard e allarmi',
    desc: 'Piattaforma cloud per visualizzare dati realtime, consultare lo storico, impostare soglie operative e ricevere notifiche quando i parametri superano i limiti configurati.',
    tags: ['Realtime', 'Storico', 'Allarmi'],
    logo: '/clotho-cloud-logo.png',
    image: '/clotho-cloud-logo.png',
  },
];

export default function Home() {
  return (
    <div className="bg-white text-slate-900">
      {/* HERO */}
      <section className="relative overflow-hidden bg-slate-950">
        <div className="absolute inset-0">
          <div className="absolute left-[-160px] top-[-140px] h-[420px] w-[420px] rounded-full bg-blue-600/25 blur-3xl" />
          <div className="absolute right-[-160px] bottom-[-160px] h-[460px] w-[460px] rounded-full bg-cyan-400/20 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.10] [background-image:radial-gradient(white_1px,transparent_1px)] [background-size:24px_24px]" />
        </div>

        <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-6 py-20 md:grid-cols-[1.05fr_0.95fr] md:py-28">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-300/20 bg-cyan-300/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-100">
              Ciesse Impianti SRL
            </div>

            <h1 className="mt-6 max-w-4xl text-4xl font-extrabold leading-tight text-white md:text-6xl">
              Assistenza tecnica, impianti e monitoraggio intelligente.
            </h1>

            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              Ciesse Impianti offre manutenzione, assistenza e certificazioni su
              camere climatiche, celle frigorifere e impianti per prove ambientali,
              integrando soluzioni IoT in collaborazione con Clotho.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contatti"
                className="rounded-xl bg-blue-600 px-6 py-3 text-center font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:bg-blue-700"
              >
                Richiedi un intervento
              </Link>

              <a
                href={CLOTHO_URL}
                target="_blank"
                rel="noreferrer"
                className="rounded-xl border border-white/15 bg-white/10 px-6 py-3 text-center font-semibold text-white backdrop-blur transition hover:bg-white/15"
              >
                Scopri Clotho
              </a>
            </div>

            <div className="mt-8 grid max-w-2xl grid-cols-3 gap-3">
              {['Centro Italia', 'Certificazioni', 'IoT & Allarmi'].map((item) => (
                <div
                  key={item}
                  className="rounded-2xl border border-white/10 bg-white/[0.06] p-4 text-center backdrop-blur"
                >
                  <p className="text-sm font-semibold text-white">{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 rounded-[36px] bg-gradient-to-r from-blue-500/30 to-cyan-400/20 blur-3xl" />

            <div className="relative overflow-hidden rounded-[32px] border border-white/10 bg-white/[0.04] p-4 shadow-2xl">
              <img
                src="/celle.jpg"
                alt="Celle frigorifere e camere climatiche"
                className="aspect-[4/3] w-full rounded-[24px] object-cover"
              />

              <div className="absolute bottom-8 left-8 right-8 rounded-2xl border border-white/10 bg-black/60 p-5 text-white backdrop-blur-xl">
                <p className="text-xs uppercase tracking-[0.22em] text-cyan-200">
                  Collaborazione tecnologica
                </p>
                <h2 className="mt-2 text-2xl font-bold">Ciesse × Clotho</h2>
                <p className="mt-2 text-sm leading-6 text-white/75">
                  Assistenza tecnica sul campo e soluzioni IoT per ambienti critici.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PARTNERSHIP */}
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl gap-8 px-6 py-12 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
              Partnership tecnologica
            </p>

            <h2 className="mt-2 text-2xl font-bold text-slate-950 md:text-3xl">
              Ciesse collabora con Clotho per portare monitoraggio e connettività negli impianti.
            </h2>

            <p className="mt-3 max-w-2xl leading-7 text-slate-600">
              Alla competenza tecnica sul campo affianchiamo dispositivi IoT,
              comunicazione LoRa e piattaforme di controllo per ridurre rischi,
              tempi di fermo e interventi non programmati.
            </p>
          </div>

          <a
            href={CLOTHO_URL}
            target="_blank"
            rel="noreferrer"
            className="flex min-h-[150px] items-center justify-center rounded-3xl border border-slate-800 bg-slate-950 p-8 shadow-xl transition hover:-translate-y-1 hover:shadow-2xl"
          >
            <img
              src="/clotho-logo.png"
              alt="Clotho"
              className="max-h-28 w-full object-contain"
            />
          </a>
        </div>
      </section>

      {/* CIESSE INFO */}
      <section className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
              Ciesse Impianti
            </p>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
              Tecnici specializzati per celle, camere ambientali e impianti critici.
            </h2>

            <p className="mt-4 leading-7 text-slate-600">
              Fondata a marzo 2025 con sede nel comune di Todi, Ciesse Impianti
              opera principalmente nel Centro Italia e in parte dell’Emilia Romagna.
              L’obiettivo è offrire interventi rapidi, documentati e affidabili.
            </p>
          </div>

          <div className="grid gap-5 md:grid-cols-3">
            {ciesseServices.map((service) => (
              <div
                key={service.title}
                className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="mb-4 h-10 w-10 rounded-xl bg-blue-50 text-blue-700 ring-1 ring-blue-100">
                  <div className="flex h-full w-full items-center justify-center text-lg font-black">
                    ✓
                  </div>
                </div>

                <h3 className="font-bold text-slate-950">{service.title}</h3>

                <p className="mt-2 text-sm leading-6 text-slate-600">
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CLOTHO ECOSYSTEM */}
      <section className="border-y border-slate-200 bg-slate-950">
        <div className="mx-auto max-w-7xl px-6 py-16 text-white">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-cyan-300">
              Ecosistema Clotho
            </p>

            <h2 className="mt-3 text-3xl font-bold tracking-tight md:text-4xl">
              Pulse, Nexus e Cloud: dal dato in campo alla supervisione.
            </h2>

            <p className="mt-4 leading-7 text-white/70">
              Pulse acquisisce i dati. Nexus li raccoglie e li trasmette.
              Cloud li rende disponibili in dashboard con storico, soglie,
              notifiche e allarmi.
            </p>
          </div>

          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {clothoProducts.map((product) => (
              <a
                key={product.name}
                href={CLOTHO_URL}
                target="_blank"
                rel="noreferrer"
                className="group flex min-h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-slate-900 backdrop-blur transition hover:-translate-y-1 hover:bg-slate-900/80 hover:shadow-2xl hover:shadow-cyan-500/10"
              >
                <div className="flex h-[280px] items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="max-h-full w-full rounded-2xl object-contain transition duration-500 group-hover:scale-[1.03]"
                  />
                </div>

                <div className="flex flex-1 flex-col justify-between p-6">
                  <div>
                    <div className="mb-5 flex min-h-[86px] items-center justify-center rounded-2xl border border-white/10 bg-slate-950 p-4">
                      <img
                        src={product.logo}
                        alt={`${product.name} logo`}
                        className="max-h-16 w-full object-contain"
                      />
                    </div>

                    <p className="text-xs uppercase tracking-[0.22em] text-cyan-300/80">
                      {product.label}
                    </p>

                    <h3 className="mt-2 text-2xl font-bold">{product.name}</h3>

                    <p className="mt-3 text-sm leading-6 text-white/70">
                      {product.desc}
                    </p>

                    <div className="mt-5 flex flex-wrap gap-2">
                      {product.tags.map((tag) => (
                        <span
                          key={tag}
                          className="rounded-full border border-cyan-300/20 bg-cyan-300/10 px-3 py-1 text-xs font-semibold text-cyan-100"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mt-7 inline-flex items-center text-sm font-semibold text-cyan-200">
                    Scopri su Clotho
                    <span className="ml-2 transition group-hover:translate-x-1">
                      →
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* METODO */}
      <section className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
              Metodo operativo
            </p>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
              Intervento tecnico e dati sempre tracciabili.
            </h2>

            <p className="mt-4 leading-7 text-slate-600">
              Uniamo competenza sul campo e strumenti digitali: pianificazione,
              reportistica, gestione allarmi e storico dati per aiutare aziende,
              laboratori, ospedali, bar e ristoranti a ridurre tempi di fermo e rischi.
            </p>
          </div>

          <div className="grid gap-3">
            {[
              'Sopralluogo e analisi dell’impianto',
              'Intervento tecnico documentato',
              'Certificazioni temperatura e umidità',
              'Monitoraggio e allarmi con tecnologia Clotho',
            ].map((step, index) => (
              <div
                key={step}
                className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-600 text-sm font-bold text-white">
                  {index + 1}
                </span>

                <span className="font-medium text-slate-800">{step}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative overflow-hidden bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-600">
        <div className="absolute inset-0 opacity-[0.16] [background-image:radial-gradient(white_1px,transparent_1px)] [background-size:22px_22px]" />

        <div className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 py-12 text-white md:flex-row md:items-center">
          <div>
            <h3 className="text-2xl font-bold md:text-3xl">
              Vuoi assistenza o monitoraggio per il tuo impianto?
            </h3>

            <p className="mt-2 max-w-2xl text-white/85">
              Ciesse segue la parte tecnica. Clotho abilita sensori, connettività e controllo.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contatti"
              className="rounded-xl bg-white px-6 py-3 text-center font-semibold text-slate-950 transition hover:bg-white/90"
            >
              Contatta Ciesse
            </Link>

            <a
              href={CLOTHO_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-white/20 bg-white/10 px-6 py-3 text-center font-semibold text-white backdrop-blur transition hover:bg-white/15"
            >
              Visita Clotho
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}